


const Home = () =>{



    return <>
    <div
      className="text-center home-bg-container d-flex justify-content-center flex-column"
    >
      <div style={{color: "#ffffff"}}>
        <h1>Get Delicious Food Anytime</h1>
        <p>{"Eat Smart & Healthy"}</p>
        <button className="btn btn-warning">View Menu</button>
        <button className="btn btn-light">Order Now</button>
      </div>
    </div>
    </>
}


export default Home;